import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Card, Menu, Button, Dropdown, Modal } from 'antd';
import colors from '../../theme/colors'

const styles = {
    button: () => ({
        backgroundColor: colors.APCO,
        color: colors.WHITE,
        borderColor: colors.APCO,
    })
}
const LoginButton = () => {
    const { loginWithRedirect } = useAuth0();

    return (
        <Button
            style={styles.button()}
            block
            onClick={() => loginWithRedirect()}>
            Login with SSO
        </Button>
    );
};

export default LoginButton;